import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectModule } from '@openng/optimus-ui/select';
import { Segment } from '../../../../models/email-template/segment.interface';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { segmentsForSelect } from '../../../../utils/segments-helper';

@Component({
    selector: 'app-segment-dropdown',
    imports: [FormsModule, SelectModule, CommonModule],
    templateUrl: './segment-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './segment-dropdown.component.scss'
})
export class SegmentDropdownComponent implements OnInit {
  segments!: Segment[];

  @Input() selectedSegment: Segment | undefined;
  @Output() selectedSegmentChange = new EventEmitter<Segment>();

  ngOnInit(): void {
    this.segments = segmentsForSelect;
  }

  emitSegmentChange(isCleared: boolean = false) {
    this.selectedSegmentChange.emit(this.selectedSegment);
  }
}
